import { BaseJsonSchema, createSchemaByBasicTypes } from "../../../helpers";

export const GumgumBidSchema: BaseJsonSchema = {
  type: "object",
  properties: {
    bidder: {
      type: "string",
      enum: ["gumgum"],
    },
    params: {
      type: "object",
      properties: {
        zone: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
        pubId: createSchemaByBasicTypes("number", null, {
          additionalProperties: false,
        }),
      },
      required: ["zone", "pubId"],
    },
  },
  additionalProperties: false,
  required: ["bidder", "params"],
};
